// extracted by mini-css-extract-plugin
module.exports = {"tab-container":"style_tab-container__3MCi8","tab":"style_tab__qEzsi","selected":"style_selected__13A4E"};